<template>
   <v-app id="inspire">
    <v-card-title>
      Media Collections
      <v-spacer></v-spacer>
        <v-dialog width="unset" height="unset" v-model="dialogs.upload">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="openNewMediaDialog()" class="ml-5" color="secondary" v-bind="attrs" v-on="on">New</v-btn>
        </template>
        <v-card class="pa-2" background="white" width="400">
          <v-card-title> Upload media collection </v-card-title>
            <v-textarea v-model="mediaCollectionJson" label="New media collection" clearable no-resize rows="17"> </v-textarea>
          <v-card-actions>
            <v-btn
              @click="uploadMediaCollection()"
              right
              :loading="uploading"
              :disabled="uploading || !validFileSpecified"
              color="primary"
            >
              Upload
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <div style="margin: 10px; text-color: white;" v-if="!this.jsonStructureValid" class="error"> JSON structure is not valid </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getMediaCollections"
      :expanded.sync="expanded"
      :hide-default-footer="true"
      disable-pagination
      show-expand
      single-expand
      item-key="id"
    > 
      <template v-slot:item.released="{ item }">
            <v-icon v-if="item.released== 'RELEASED'">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
    </template>
       <template v-slot:expanded-item="{ headers, item: parentItem  }">
        <td :colspan="headers.length">
          <v-card-actions>
            <v-btn
              @click="
                increaseVersion = 'RELEASE';
                generateRelease();
              "
              color="secondary"
              >Generate Release</v-btn
            >
          </v-card-actions>

          <v-data-table :headers="subHeaders" :items="mediaCollectionReleases" item-key="id">
            <!-- ACTIONS -->
            <template v-slot:item.actions="{ item }">
              <!-- CHANGE PUBLICATION STATUS BUTTON -->
              <v-btn
                icon
                @click="
                  openPublicationStatusChangeDialog(
                    item.id,
                    item.publicationStatus
                  )
                "
              >
                <v-icon>mdi-earth</v-icon>
              </v-btn>
              <v-btn icon @click="downloadRelease(item, parentItem.id)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <!-- DELETE BUTTON -->
              <v-btn icon @click="deleteRelease(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE -->
        <v-btn icon @click="openEditDialog(item)" color="secondary"
        ><v-icon>mdi-pencil</v-icon></v-btn> 
        <v-btn icon @click="deleteMediaCollections(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
    <v-dialog v-model="dialogs.changePublicationStatus" max-width="400px">
      <v-card>
        <v-card-title>
          <h3 class="publication-status-title">Change Publication Status</h3>
        </v-card-title>
        <v-card-text class="publication-status-container">
          <v-radio-group v-model="publicationStatus">
            <v-radio
              v-for="item in publicationStatusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
          <v-btn @click="changePublicationStatus">Change</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import {
    GET_MEDIA_COLLECTION_QUERY,
    GET_AUDIO_COLLECTION_QUERY,
    ADD_OR_UPDATE_MEDIA_COLLECTIONS_JSON,
    DELETE_MEDIA_COLLECTION,
    GENERATE_MEDIA_COLLECTION_RELEASE,
    GET_MEDIA_COLLECTION_RELEASE_FILTER_QUERY,
    DELETE_MEDIA_COLLECTION_RELEASE,
    GET_MEDIA_FILES_BY_COLLECTION_RELEASE_QUERY,
    UPDATE_MEDIA_COLLECTION_RELEASE_PUBLICATION_STATUS
  } from '../../graphql/shootingProgramQueries.js';

  import { DownloadFile } from "../../utils/UBinaryStorage";

  export default {
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    name: 'MediaCollections',
    data: () => ({
      mediaCollectionJson: '',
      currentAudioId: null,
      uploading: false,
      updatingMediaCollection: false,
      search: '',
      jsonStructureValid: true,
      expanded: [],
      increaseVersion: '',
      publicationStatus: null, // The publication status to update the release to
      publicationStatusChangeReleaseId: null, // The template release to change the publication status of
      publicationStatusOptions: [
        {
          name: 'Internal',
          value: 'INTERNAL',
        },
        {
          name: 'Public',
          value: 'PUBLIC',
        },
      ],
      dialogs: {
          upload: false,
          changePublicationStatus: false,
      },
      mediaCollectionReleases: [],
       headers: [
          { text: 'Name', value: 'name'},
          { text: 'Version', value: 'version'},
          { text: 'Released', value: 'released', sortable: false},
          {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
        ],
        subHeaders: [
          { text: 'Major', value: 'versionMajor', sortable: false, width: '40px' },
          { text: 'Minor', value: 'versionMinor', sortable: false, width: '40px' },
          { text: 'Patch', value: 'versionPatch', sortable: false, width: '40px' },
          { text: 'Date', value: 'dateTime', sortable: false },
          { text: 'Publication', value: 'publicationStatus', sortable: false },
          {
            text: '',
            value: 'actions',
            sortable: false,
            align: 'right',
            width: '18%',
          },
        ],
    }),
    apollo: {
      $client: 'shootingProgramClient',
      getAudioCollections: {
        query: GET_AUDIO_COLLECTION_QUERY,
        loadingKey: 'loading',
        options: { fetchPolicy: 'cache-and-network' },
      },
      getMediaCollections: {
        query: GET_MEDIA_COLLECTION_QUERY,
        loadingKey: 'loading',
        options: { fetchPolicy: 'cache-and-network' },
      },
    },
    watch: {
      expanded(expanded) {
        if(expanded.length > 0)
          this.fetchReleases(expanded[0].id);
      }
    },

    computed: {
      validFileSpecified() {
        return this.mediaCollectionJson !== undefined && this.mediaCollectionJson.length > 0;
      },
    },
    methods: {
      openNewMediaDialog(){
        this.uploading = false; 
        this.updatingMediaCollection = false;
      },
      openEditDialog(collection){
        this.dialogs.upload = true;
        this.mediaCollectionJson = JSON.stringify(collection, null, 2);
        this.updatingMediaCollection = true;
        this.currentAudioId = collection.id;
        this.uploading = false; 
      },
      async fetchReleases(id){
          const result = await this.$apollo.query({ 
            query: GET_MEDIA_COLLECTION_RELEASE_FILTER_QUERY,
            variables: {
                id: id, 
                limit: 10
            },
            fetchPolicy: 'network-only',
          })
          this.mediaCollectionReleases = result.data?.getMediaCollectionReleaseByFilter;
      },
      refetchMediaCollections() {
        this.$apollo.queries.getMediaCollections.refetch();
      },
      async deleteMediaCollections(id){
        if (
          await this.$refs.confirmationDialog.open(
            'Are you sure you want to delete this media collection?'
          )
        ) {
          try {
              await this.$apollo.mutate({
                  mutation: DELETE_MEDIA_COLLECTION,
                  variables: {
                    id: id,
                  },
              });
          } catch (err) {
            alert('Error deleting media collection! ' + err.message);
          }
          this.refetchMediaCollections();
        }
      },
        async uploadMediaCollection(){
          try{
            JSON.parse(this.mediaCollectionJson); 
            this.jsonStructureValid = true;
          }catch(ex){
           this.jsonStructureValid = false;
           return;
          }

          if (this.validFileSpecified && this.jsonStructureValid) {
          try {
            // Set uploading state to indicate that the upload process is ongoing
            this.uploading = true;
            let id = null;

            if(this.updatingMediaCollection){
              id = this.currentAudioId;
            }

            await this.$apollo.mutate({
              mutation: ADD_OR_UPDATE_MEDIA_COLLECTIONS_JSON,
              variables: {
                id: id,
                mediaCollectionJson: this.mediaCollectionJson
              },
            });

            this.updatingMediaCollection = false;
            this.dialogs.upload = false;
            this.refetchMediaCollections();
          } catch (error) {
            console.error(error);
            this.uploading = false;
          }
          
 
        }
        },
        async generateRelease(){
          try {
            const collectionId = this.expanded[0].id;
            await this.$apollo.mutate({
              mutation: GENERATE_MEDIA_COLLECTION_RELEASE,
              variables: {
                mediaCollectionId: collectionId,
                increaseVersion: this.increaseVersion,
              },
            }).then(() => this.fetchReleases(collectionId));
            this.increaseVersion = '';
            this.refetchMediaCollections();
            
          } catch (error) {
            alert('The service was not able to generate media collection release.');
            this.increaseVersion = '';
          }
        },
        async downloadRelease(release, collectionId){
          const result = await this.$apollo.query({ 
            query: GET_MEDIA_FILES_BY_COLLECTION_RELEASE_QUERY,
            variables: {
                id: release.id, 
            },
            fetchPolicy: 'network-only',
          })

          DownloadFile(release, result.data?.getMediaFilesByCollectionRelease ,collectionId);
        },
        async deleteRelease(id){
          if (
              await this.$refs.confirmationDialog.open(
                'Are you sure you want to delete this media collection release?'
              )
            ) {
              try {
                  await this.$apollo.mutate({
                      mutation: DELETE_MEDIA_COLLECTION_RELEASE,
                      variables: {
                        id: id,
                      },
                  });
              } catch (err) {
                alert('Error deleting media collection! ' + err.message);
              }
              this.fetchReleases(this.expanded[0].id);
          }
        },
        openPublicationStatusChangeDialog(
      shootingProgramTemplateReleaseId,
      currentPublicationStatus
    ) {
      this.publicationStatus = currentPublicationStatus;
      this.publicationStatusChangeReleaseId = shootingProgramTemplateReleaseId;
      this.dialogs.changePublicationStatus = true;
    },    
    async changePublicationStatus() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_MEDIA_COLLECTION_RELEASE_PUBLICATION_STATUS,
          variables: {
            id: this.publicationStatusChangeReleaseId,
            publicationStatus: this.publicationStatus,
          },
        });

        this.dialogs.changePublicationStatus = false;
        this.publicationStatusChangeReleaseId = null;
      } catch (error) {
        alert('Error changing publication status! ' + error.message);
      }
      this.fetchReleases(this.expanded[0].id);
    },
  }
  };
</script>


<style scoped>
</style>
